import { GridOptions, ICellRendererParams } from '@ag-grid-community/core'
import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import {
  disableChangeDetectionOnScroll,
  enableHeliosGridDensityLevel,
} from '@helios/ag-grid-config'
import {
  DensityLevel,
  UserPreferencesService,
  WorkspaceGridSavedViewService,
} from '@helios/user-preferences'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { GridComponents } from '@northfork/ag-grid'
import { ModalLinkComponent } from '@northfork/ag-grid-angular'
import { composeFieldPath } from '@northfork/basics'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import {
  ClientCustodyContact,
  TransportDetails,
} from '../../../models/account-details.model'

@Component({
  selector: 'hs-custody-contacts',
  templateUrl: './custody-contacts-modal.component.html',
  styleUrls: ['./custody-contacts-modal.component.scss'],
})
export class CustodyContactsModalComponent
  implements ModalLinkComponent<TransportDetails>, OnInit
{
  data?: TransportDetails
  params?: ICellRendererParams

  custodyContacts: ClientCustodyContact[] = []

  private readonly custodyContactField = composeFieldPath(this.custodyContacts)
  emailsAll = ''

  private readonly destroySubject$ = new Subject<void>()

  gridOptionsContactDetails: GridOptions = {
    sideBar: false,
    ...disableChangeDetectionOnScroll(this.changeDetector),
    onGridReady: event => {
      event.api.setDomLayout('autoHeight')

      this.preferences
        .getDensityLevel()
        .pipe(takeUntil(this.destroySubject$))
        .subscribe(level =>
          enableHeliosGridDensityLevel(
            event.api,
            DensityLevel.Compact === level,
          ),
        )
    },
    columnDefs: [
      {
        field: this.custodyContactField('firstName'),
        headerName: 'Name',
        valueGetter: params =>
          params.data.firstName + ' ' + params.data.lastName,
        width: 350,
      },
      {
        field: this.custodyContactField('phoneNumber'),
        headerName: 'Phone Number',
        width: 100,
      },
      {
        field: this.custodyContactField('email'),
        headerName: 'Email Custody',
        cellRenderer: undefined,
        width: 330,
        cellRendererSelector: (params: ICellRendererParams) => {
          return this.computeRenderer(params)
        },
      },
    ],
  }

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly preferences: UserPreferencesService,
    private readonly savedViewService: WorkspaceGridSavedViewService,
    readonly activeModal: NgbActiveModal,
  ) {}
  ngOnInit(): void {
    if (this.data) this.custodyContacts = this.data.contacts
    this.emailsAll = this.getEmails()
  }

  ngOnDestroy(): void {
    this.destroySubject$.next()
    this.destroySubject$.complete()
  }

  computeRenderer(params: ICellRendererParams) {
    return {
      component: GridComponents.linkRenderer,
      params: {
        url: 'mailto:' + params.data.email,
        newWindow: true,
      },
    }
  }

  getEmails(): string {
    return this.custodyContacts
      .filter(contact => contact.email != '')
      .map(contact => contact.email)
      .join(';')
  }
}
